//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ImprovedAndSimplified_MDRD",
  data() {
    return {
      form: {
        type:'',
        sex: "0",
        chinese:"0",
        age: "",
        blood:''
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "1", name: "碱性苦味酸动力法 Beckman CX3" },
        { value: "2", name: "碱性苦味酸动力法 Hatichi " },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let multiple = 1
      let result = ''
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      console.log(form);
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        if(form.type == 1) {
          result = (186 * Math.pow(form.blood,-1.154) * Math.pow(form.age,-0.203) * (form.sex ? 1:0.742) * (form.chinese ? 1.233 : 1)).toFixed(2)
        }else {
          result = (175  * Math.pow(form.blood,-1.234) * Math.pow(form.age,-0.179) * (form.sex ? 1 : 0.79)).toFixed(2)
        }
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ImprovedAndSimplified_MDRD.vue